import { createIcon } from './factory'
import Bold from './warning-circle.bold.svg?react'
import Duotone from './warning-circle.duotone.svg?react'
import Fill from './warning-circle.fill.svg?react'
import Regular from './warning-circle.regular.svg?react'

export const WarningCircle = createIcon({
  regular: Regular,
  bold: Bold,
  fill: Fill,
  duotone: Duotone,
})
